import styled from 'styled-components';

export const HRC = styled.div``;
